// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".5adff546f2cf3966c97a0c528b8d570f13a82bb6.chunk.js";
};